import { blue90 } from '../../../colors/blue';
import { black, gray05, white } from '../../../colors/gray';
import { red03 } from '../../../colors/red';
import { yellow02 } from '../../../colors/yellow';
import { rem } from '../../../utils/rem';
export var MuiBadge = {
    defaultProps: { max: 99 },
    styleOverrides: {
        badge: {
            borderRadius: rem(5),
            color: blue90,
            border: "".concat(rem(2), " solid ").concat(white),
            backgroundColor: yellow02,
            paddingBlock: 0,
            paddingInline: rem(4),
            height: rem(21),
        },
        colorError: {
            color: white,
            backgroundColor: red03,
        },
        colorSecondary: {
            color: black,
            backgroundColor: gray05,
        },
        anchorOriginTopRightRectangular: {
            transform: 'scale(1) translate(75%, -50%)',
        },
    },
};
